module.exports = __webpack_public_path__ + "img/commentsign.b3f9258a.svg";